import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-circle-solid.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-213b7d09")

_pushScopeId("data-v-213b7d09")
const _hoisted_1 = {
  key: 1,
  class: "overflow-y-auto h-screen"
}
const _hoisted_2 = { class: "\n        flex flex-row\n        justify-between\n        items-center\n        border-b border-gray-lp-400\n      " }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Ubah Vendor ", -1)
const _hoisted_5 = {
  key: 0,
  class: "inline-flex"
}
const _hoisted_6 = {
  key: 1,
  class: "inline-flex"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("button", { class: "\n              text-white\n              bg-gray-lp-600\n              px-8\n              text-12px xxl:text-14px\n              py-2\n              xxl:py-3\n              font-bold\n              rounded-md\n              focus:outline-none\n            " }, " Simpan ", -1)
const _hoisted_8 = { class: "flex flex-row py-6" }
const _hoisted_9 = { class: "w-2/3 px-4 text-12px xxl:text-14px" }
const _hoisted_10 = { class: "w-3/4" }
const _hoisted_11 = { class: "flex flex-row py-3" }
const _hoisted_12 = { class: "w-1/2 mr-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama Vendor", -1)
const _hoisted_14 = { class: "w-1/2 mr-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kode Vendor", -1)
const _hoisted_16 = { class: "py-3" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Alamat", -1)
const _hoisted_18 = { class: "flex flex-row py-3" }
const _hoisted_19 = { class: "w-1/2 mr-4" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Email", -1)
const _hoisted_21 = { class: "inline-block relative w-full" }
const _hoisted_22 = { class: "\n                    pointer-events-none\n                    absolute\n                    inset-y-0\n                    right-0\n                    flex\n                    items-center\n                    px-2\n                    text-gray-700\n                  " }
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 mr-3"
}, null, -1)
const _hoisted_24 = { class: "text-red-lp-100 text-12px xxl:text-14px whitespace-no-wrap" }
const _hoisted_25 = { class: "w-1/2" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "No. Telepon", -1)
const _hoisted_27 = { class: "flex flex-row items-center relative w-full" }
const _hoisted_28 = { class: "\n                    pointer-events-none\n                    absolute\n                    inset-y-0\n                    right-0\n                    flex\n                    items-center\n                    px-2\n                    text-gray-700\n                  " }
const _hoisted_29 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 mr-3"
}, null, -1)
const _hoisted_30 = { class: "text-red-lp-100 text-12px xxl:text-14px whitespace-no-wrap" }
const _hoisted_31 = { class: "flex flex-row py-3" }
const _hoisted_32 = { class: "w-1/2 mr-4" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " No. Registrasi Pajak (NPWP) ", -1)
const _hoisted_34 = { class: "inline-block relative w-full" }
const _hoisted_35 = { class: "\n                    pointer-events-none\n                    absolute\n                    inset-y-0\n                    right-0\n                    flex\n                    items-center\n                    px-2\n                    text-gray-700\n                  " }
const _hoisted_36 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 mr-3"
}, null, -1)
const _hoisted_37 = { class: "text-red-lp-100 text-12px xxl:text-14px whitespace-no-wrap" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Masukkan No. Registrasi Pajak (NPWP) ")
const _hoisted_39 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" dengan benar")
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_42 = { class: "flex flex-col text-12px border-t border-gray-lp-400 my-3 py-3" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-black-lp-300" }, " Periode Kontrak "),
  /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500 max-w-md" }, " Kontrak akan berlaku sesuai dengan tanggal periode yang dipilih. ")
], -1)
const _hoisted_44 = { class: "w-2/3 flex flex-row py-3" }
const _hoisted_45 = { class: "w-1/2 mr-4" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, " Dimulai Dari ", -1)
const _hoisted_47 = { class: "text-red-lp-100 text-12px xxl:text-14px whitespace-no-wrap" }
const _hoisted_48 = { class: "text-red-lp-100 text-12px xxl:text-14px whitespace-no-wrap" }
const _hoisted_49 = { class: "w-1/2" }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, "Sampai", -1)
const _hoisted_51 = { class: "flex flex-col text-12px border-t border-gray-lp-400 mb-3 py-6" }
const _hoisted_52 = { class: "py-3" }
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-12px xxl:text-14px text-black-lp-300" }, " Status Vendor ", -1)
const _hoisted_54 = { class: "my-1 text-gray-lp-500 max-w-md" }
const _hoisted_55 = { class: "flex flex-row text-12px xxl:text-14px items-center text-black-lp-300" }
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_57 = { class: "ml-4" }
const _hoisted_58 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_59 = { class: "py-3" }
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Status Vendor", -1)
const _hoisted_61 = { class: "my-1 text-black-lp-300" }
const _hoisted_62 = { class: "flex" }
const _hoisted_63 = { class: "capitalize" }
const _hoisted_64 = { class: "py-3" }
const _hoisted_65 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_66 = { class: "text-gray-lp-300 my-1" }
const _hoisted_67 = { class: "text-gray-lp-500" }
const _hoisted_68 = { class: "py-3" }
const _hoisted_69 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Diubah", -1)
const _hoisted_70 = { class: "text-gray-lp-300 my-1" }
const _hoisted_71 = { class: "text-gray-lp-500" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_DatePickerV2 = _resolveComponent("DatePickerV2")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer"
              }),
              _hoisted_4
            ]),
            _createVNode("div", null, [
              (!_ctx.isDisabledButton())
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _createVNode(_component_button_fill, {
                      title: "Simpan",
                      onClick: _ctx.openModalSave,
                      class: "px-8 bg-red-lp-300"
                    }, null, 8, ["onClick"])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_6, [
                    _hoisted_7
                  ]))
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailVendor.name = $event)),
                      class: 
                  `py-1.5 xxl:py-3 px-3 rounded border opacity-50 border-gray-lp-400 focus:outline-none text-black-lp-200 my-2 w-full ${_ctx.isDisabled &&
                    'bg-white'}`
                ,
                      disabled: _ctx.isDisabled
                    }, null, 10, ["disabled"]), [
                      [_vModelText, _ctx.detailVendor.name]
                    ])
                  ]),
                  _createVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.detailVendor.code = $event)),
                      class: 
                  `py-1.5 xxl:py-3 px-3 rounded border opacity-50 border-gray-lp-400 focus:outline-none text-black-lp-200 my-2 w-full ${_ctx.isDisabled &&
                    'bg-white'}`
                ,
                      disabled: _ctx.isDisabled
                    }, null, 10, ["disabled"]), [
                      [_vModelText, _ctx.detailVendor.code]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createVNode("textarea", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.detailVendor.address = $event)),
                    class: "\n                pt-4\n                pb-8\n                xxl:pt-4\n                xxl:pb-10\n                px-3\n                rounded\n                border border-gray-lp-400\n                focus:outline-none\n                focus:shadow\n                my-1.5\n                text-black-lp-300\n                w-full\n                resize-none\n              "
                  }, null, 512), [
                    [_vModelText, _ctx.detailVendor.address]
                  ])
                ]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode("div", _hoisted_21, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args))),
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.detailVendor.email = $event)),
                        placeholder: "e.g email@gmail.com",
                        onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                        class: 
                    _ctx.validEmail
                      ? 'py-1.5 xxl:py-3 px-3 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full'
                      : 'focus:border-red-lp-100 focus:outline-none py-1.5 xxl:py-3 px-3 rounded border my-1.5 border-red-lp-100 w-full'
                  
                      }, null, 34), [
                        [_vModelText, _ctx.detailVendor.email]
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_22, [
                        _hoisted_23
                      ], 512), [
                        [_vShow, !_ctx.validEmail]
                      ])
                    ]),
                    _withDirectives(_createVNode("span", _hoisted_24, "Masukan Email dengan benar", 512), [
                      [_vShow, !_ctx.validEmail]
                    ])
                  ]),
                  _createVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode("div", _hoisted_27, [
                      _createVNode("div", {
                        class: 
                    _ctx.detailVendor.phone_number.length < 5
                      ? 'border-red-lp-100 bg-gray-lp-700 rounded-l-md border-r-0 text-black-lp-300 text-center my-1.5 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2'
                      : 'bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2'
                  
                      }, " +62 ", 2),
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                        maxlength: "13",
                        onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.validatePhoneNumber())),
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.detailVendor.phone_number = $event)),
                        class: 
                    _ctx.detailVendor.phone_number.length < 5
                      ? 'focus:border-red-lp-100 focus:outline-none py-1.5 xxl:py-3 px-3 rounded border my-1.5 border-red-lp-100 w-full'
                      : 'py-1.5 xxl:py-3 px-3 rounded-l-none rounded-r-md border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full'
                  
                      }, null, 34), [
                        [_vModelText, _ctx.detailVendor.phone_number]
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_28, [
                        _hoisted_29
                      ], 512), [
                        [_vShow, _ctx.detailVendor.phone_number.length < 5]
                      ])
                    ]),
                    _withDirectives(_createVNode("span", _hoisted_30, "Masukkan No. Telepon dengan benar", 512), [
                      [_vShow, _ctx.detailVendor.phone_number.length < 5]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode("div", _hoisted_34, [
                      _createVNode("div", {
                        class: 
                    _ctx.detailVendor.tax_number.length < 20
                      ? 'flex flex-row items-center focus:border-red-lp-100 focus:outline-none py-1.5 xxl:py-3 px-3 rounded border my-1.5 border-red-lp-100 w-full'
                      : 'custom-input-regtax xxl:py-3'
                  
                      }, [
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          maxlength: "20",
                          placeholder: "e.g 999999999999999",
                          class: "focus:outline-none w-full",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.detailVendor.tax_number = $event)),
                          onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.formatted && _ctx.formatted(...args)))
                        }, null, 544), [
                          [_vModelText, _ctx.detailVendor.tax_number]
                        ]),
                        _withDirectives(_createVNode("p", { class: "font-normal text-length-tax" }, _toDisplayString(_ctx.detailVendor.tax_number.length) + "/20 ", 513), [
                          [_vShow, _ctx.detailVendor.tax_number.length === 20]
                        ])
                      ], 2),
                      _withDirectives(_createVNode("div", _hoisted_35, [
                        _hoisted_36
                      ], 512), [
                        [_vShow, _ctx.detailVendor.tax_number.length < 20]
                      ])
                    ]),
                    _withDirectives(_createVNode("span", _hoisted_37, [
                      _hoisted_38,
                      _hoisted_39,
                      _hoisted_40
                    ], 512), [
                      [_vShow, _ctx.detailVendor.tax_number.length < 20]
                    ])
                  ]),
                  _hoisted_41
                ])
              ]),
              _createVNode("div", _hoisted_42, [
                _hoisted_43,
                _createVNode("div", _hoisted_44, [
                  _createVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createVNode(_component_DatePickerV2, {
                      disabled: _ctx.invalidEndDate,
                      modelValue: _ctx.contractStart,
                      onSelected: _ctx.inputDateStart
                    }, null, 8, ["disabled", "modelValue", "onSelected"]),
                    _withDirectives(_createVNode("span", _hoisted_47, "Tanggal mulai tidak boleh lebih atau sama dengan tanggal akhir", 512), [
                      [_vShow, _ctx.invalidStartDate]
                    ]),
                    _withDirectives(_createVNode("span", _hoisted_48, "Tanggal akhir tidak boleh kurang atau sama dengan tanggal mulai", 512), [
                      [_vShow, _ctx.invalidEndDate]
                    ])
                  ]),
                  _createVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createVNode(_component_DatePickerV2, {
                      disabled: _ctx.invalidStartDate,
                      modelValue: _ctx.contractEnd,
                      onSelected: _ctx.inputDateEnd
                    }, null, 8, ["disabled", "modelValue", "onSelected"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_51, [
                _createVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createVNode("div", _hoisted_54, " Klik tombol dibawah untuk " + _toDisplayString(!_ctx.isRoute() ? "mengaktifkan" : "menonaktifkan") + " vendor. Anda dapat mengubah status kapan saja. ", 1)
                ]),
                _createVNode("div", _hoisted_55, [
                  _createVNode("div", {
                    onClick: _cache[13] || (_cache[13] = () => _ctx.onOpenRoute()),
                    class: 
                `toggle-switch inline-block cursor-pointer ${
                  _ctx.isRoute() ? 'toggle-active bg-red-lp-100' : 'bg-gray-lp-200'
                }`
              
                  }, [
                    _hoisted_56
                  ], 2),
                  _createVNode("div", _hoisted_57, _toDisplayString(_ctx.isRoute() ? "Aktif" : "Tidak Aktif"), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_58, [
              _createVNode("div", _hoisted_59, [
                _hoisted_60,
                _createVNode("div", _hoisted_61, [
                  _createVNode("div", _hoisted_62, [
                    _createVNode("div", {
                      class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.isRoute() ? 'bg-green-lp-300' : 'bg-red-lp-600'
                  } ${_ctx.isRoute() ? 'text-green-lp-200' : 'text-red-lp-500'}`
                
                    }, [
                      _createVNode("span", _hoisted_63, _toDisplayString(_ctx.isRoute() ? "Active" : "Inactive"), 1)
                    ], 2)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_64, [
                _hoisted_65,
                _createVNode("div", _hoisted_66, _toDisplayString(_ctx.formatDate(_ctx.detailVendor.created_at)), 1),
                _createVNode("div", _hoisted_67, _toDisplayString(_ctx.detailVendor.created_by), 1)
              ]),
              _createVNode("div", _hoisted_68, [
                _hoisted_69,
                _createVNode("div", _hoisted_70, _toDisplayString(_ctx.formatDate(_ctx.detailVendor.updated_at)), 1),
                _createVNode("div", _hoisted_71, _toDisplayString(_ctx.detailVendor.updated_by), 1)
              ])
            ])
          ])
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.onCloseRoute,
      onSubmit: _ctx.changeRoute,
      title: "Konfirmasi Penonaktifan",
      message: "Penonaktifan status akan membuat vendor tidak dapat digunakan dalam Rute Mapping.",
      image: "warning",
      textSuccess: "Nonaktifkan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit"]), [
      [_vShow, _ctx.openRoute]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: "Perubahan Berhasil !",
      message: `${_ctx.messageSuccess}`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin Keluar Halaman ?",
      message: "Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onEdit,
      onClose: _ctx.closeModalSave,
      title: "Konfirmasi Perubahan Detail Vendor",
      message: 
      `Anda yakin ingin menyimpan perubahan detail Vendor “${_ctx.detailVendor.name}” ?`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave()]
    ])
  ], 64))
})